export default "__VITE_ASSET__C5Esnl09__"